import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Flame, Star, Heart, Award, Sticker, Sparkles } from "lucide-react";
import StoryPlayer from "./StoryPlayer";
import api from "../lib/api";

const seenKey = (childId, year) => `tycc_yir_${childId}_${year}`;
export const yearInReviewSeen = (childId, year) => localStorage.getItem(seenKey(childId, year)) === "1";
export const markYearInReviewSeen = (childId, year) => localStorage.setItem(seenKey(childId, year), "1");

export const buildChildSlides = (d) => {
  const name = d.child.name;
  const panda = d.child.panda;
  const certs = d.lessons.filter((l) => l.certified_this_year).length;
  return [
    { bg: "#7d5fb2", icon: Sparkles, panda, title: `${name}'s ${d.year}`, big: "Your year", sub: "Let's look back at everything you learned about money and credit." },
    { bg: "#63c79a", icon: CalendarDays, panda, title: "You showed up", big: `${d.active_days}`, sub: `active learning day${d.active_days === 1 ? "" : "s"} in ${d.year}` },
    { bg: "#f7931e", icon: Flame, panda, title: "Longest streak", big: `${d.longest_streak_weeks}w`, sub: d.longest_streak_weeks >= 4 ? "weeks in a row - that's a habit!" : "weeks in a row - keep it going this year" },
    { bg: "#f3c932", icon: Star, panda, item: "coin", title: "Bamboo earned", big: `${d.bamboo_year}`, sub: `bamboo collected · ${d.stickers_earned} sticker${d.stickers_earned === 1 ? "" : "s"} in your book`, dark: true },
    { bg: "#1b8bc9", icon: Award, panda, title: "Lessons", big: `${certs}`, sub: `certificate${certs === 1 ? "" : "s"} earned in ${d.year}${d.quiz_average !== null ? ` · quiz average ${d.quiz_average}/5` : ""}` },
    { bg: "#e5356f", icon: Heart, panda, title: "Your cheer squad", big: `${d.cheers_year}`, sub: `cheer${d.cheers_year === 1 ? "" : "s"} from the people who love you` },
    { bg: "#0c4a6e", icon: Sticker, panda, title: `Proud of you, ${name}!`, big: d.goal_badge ? `${d.goal_badge.label} badge` : "Well done", sub: "Your report card is ready - let's see the whole year on one page.", last: true, cta: `See ${name}'s report card` },
  ];
};

// Full-screen animated "year in review" story for one child; last slide opens the report card.
const YearInReview = ({ childId, year, onClose }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/children/${childId}/report-card?year=${year}`).then((r) => setData(r.data)).catch(() => onClose());
  }, [childId, year]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return <div className="fixed inset-0 z-[100] bg-[#7d5fb2]" data-testid="year-in-review-loading" />;
  return <StoryPlayer slides={buildChildSlides(data)} onClose={onClose} onFinish={() => { onClose(); navigate(`/report-card/${childId}?year=${year}`); }} testId="year-in-review" />;
};

export default YearInReview;
